import classes from "./Step.module.scss";
import {useState, useEffect} from "react";
import DoneAllIcon from '@mui/icons-material/DoneAll';

const StepSmall = ({stepNumber, onStepChange, enabledMessage, stepShortDescription,stepSubText, stepLongDescription, checked=false, completed, enabled, clickMe, id, json, ...rest}) => {
    const [selected, setSelected] = useState(false);
    const [warning, setWarning] = useState(false);
    const selectedChange = () => {
        if(!enabled)
            return;
        setSelected(!selected);
        if(onStepChange)
            onStepChange(stepNumber, !selected);
    }
    
    useEffect(() => {
        if(selected !== checked)
            setSelected(checked);
    }, [checked])

    /* useEffect(() => {
        const hasPOS = json?.Object?._details?.Payments?.some(p => p?.PayCode === "POS") ?? false;
        if(stepNumber === "36" && !hasPOS && selected){
            setWarning(true);
        } else {
            setWarning(false);
        }
    }, [json, selected]) */
    return (
        <>
        <div id={id} className={`${classes["card"]} p-3 mb-2`} onClick={() => selectedChange()} style={enabled ? {background:"white"} : {background:"#dfdfdf"}}>
            <div className="d-flex justify-content-between">
                <div className="d-flex flex-row align-items-center" style={{marginRight:"1rem"}}>
                    <div className={classes["c-icon"]}> </div>
                    <div className={`ms-2 ${classes["c-details"]}`}>
                        <div className={classes["avatar-small"]}>
                            <h4 className={`${classes["avatar-img"]} ${classes["rounded-circle"]}`} style={{textAlign:"center", paddingTop:"7px"}}>{stepNumber}</h4>
                        </div>
                    </div>
                </div>
                <div >
                    {clickMe && <div id="click-me-text" style={{fontWeight:"700", fontSize:"1rem", textAlign:"center", color:"green", marginBottom:"1rem", textDecoration:"underline"}}>Select this step</div>}
                    <div style={{fontWeight:"700", fontSize:"1rem", textAlign:"center"}}>{stepShortDescription}</div>
                    <div style={{fontWeight:"400", fontSize:"0.8rem",marginTop:"0.3rem", textAlign:"center"}}>{stepSubText}</div>
                </div>
                <div className={classes["badge"]} style={{marginLeft:"1rem"}}> 
                    {completed && <><DoneAllIcon style={{fontSize:"2rem", color:"green"}}/></>}
                    {!completed && <div className="form-check form-switch">
                        <input className="form-check-input" checked={selected} type="checkbox" role="switch" style={{"transform" : "scale(1.5)"}} onChange={selectedChange}/>
                    </div>}
                </div>
            </div>
            {enabledMessage && <div style={enabled ? {textAlign:"left", fontSize:"0.7rem", paddingTop:"0.5rem"} : {textAlign:"left", fontSize:"0.7rem", color:"#0d6efd", paddingTop:"0.5rem"}}>{enabledMessage}</div>}
            {warning && <div style={{textAlign:"left", fontSize:"0.7rem", color:"red", paddingTop:"0.5rem"}}>Warning: This step requires at least one payment to have POS selected as PayCode</div>}
        </div>
        </>
    )
}

export default StepSmall;